import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=cb05cf72&scoped=true"
import script from "./merchant.vue?vue&type=script&lang=js"
export * from "./merchant.vue?vue&type=script&lang=js"
import style0 from "./merchant.vue?vue&type=style&index=0&id=cb05cf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb05cf72",
  null
  
)

export default component.exports